export const TENANT_SETTING_ENABLE_ONLINE_SIGNUP_CHECKOUT_SECURITY =
  'enable_online_signup_checkout_security';

export const RECAPTCHA_ACTION_SAVE_CLIENT_DETAILS = 'save_client_details';

export const WIDGET_RECAPTCHA_V2_HINT_DEFAULT =
  'Complete the security check below to continue.';

export const WIDGET_RECAPTCHA_V2_HINT_LEAD_CAPTURE =
  'Complete the security check below to submit.';

export const WIDGET_RECAPTCHA_V2_HINT_TOUR_BOOKING =
  'Complete the security check below to finish booking.';

export const WIDGET_RECAPTCHA_V2_HINT_TRIAL_BOOKING =
  'Complete the security check below to finish booking your trial.';

export function isTenantSettingFlagEnabled(
  setting: { value?: string; status?: string } | null | undefined,
): boolean {
  if (!setting) {
    return false;
  }
  if (setting.status?.toLowerCase() !== 'active') {
    return false;
  }
  return setting.value?.trim().toLowerCase() === 'true';
}
